import React, { useState, useEffect, useRef } from 'react';
import { Button, Form, Row, Col, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import DataTable from 'react-data-table-component';

import { AddUpdate } from '../../../ApiMethods/ApiMethods';
import { customStyles } from '../Utility/Utility';
import user from './../../../images/task/user.jpg';
import Loader from '../Loader/Loader';
import AstroTimeTable from './AstroTimeTable';




const WaitingList = () => {


  const AstroData = useSelector((state) => state.feedBackReducer.AstroData);




  const [searchQuery, setSearchQuery] = useState('');


  const [loading, setLoading] = useState(false)
  const [filters, setFilters] = useState({ name: '', mobile: '', status: '' });
  const [sortField, setSortField] = useState('');
  const [sortOrder, setSortOrder] = useState('asc');
 const [timeData, setTimeData] = useState([]);
  const [firstrowData, setFirstrowData] = useState([]);
  const itemsPerPage = 10;

  const [astrodata, setAstrodata] = useState([])
  const [astroId, setAstroId] = useState("")

  const [form, setForm] = useState({
    name: "",
    mobile: "",
    email: "",
    dob: "",
    dot: "",
    placeOfBirth: "",
    address: "",
    city: "",
    pinCode: "",
    panCard: "",
    aadhar: "",
    maritalStatus: "",
    gender: "",
    image: null,
    imagePreview: null,
    aboutMe: "",
    qualification: "",
    bankName: "",
    accountNumber: "",
    ifscCode: "",
    branchName: "",
    attachment: null,
    attachmentName: "",
    attachmentPreview: null,
    review: "",
  });

  const [showModal, setShowModal] = useState(false);
  const [selectedAstro, setSelectedAstro] = useState(null);
  const [model,setModel]=useState(false)

  const [TimetablePopUPOpen, setTimetableIsPopupOpen] = useState(false);
 const [AstroAvailabledata, setAstroAvailabledata] = useState([])
 const [isTimeTableOpen, setIsTimeTableOpen] = useState(false);






  const waitingdata = async () => {
    setLoading(true);
    const val = {
      "AstroId": "",
    }
    try {
      // const res = await AddUpdate("WaitingList/GetData_WaitingListUser", val);
    const res = await AddUpdate("Astrologer/AstrologerAvailability", val);

     

      
      if (!res || !res.data) {
        console.error("API response is empty or invalid");
        setAstrodata([]);
        return;
      }

      const Data = res?.data?.data;
    
      
     
      if (!Data || typeof Data !== 'string') {
        console.error("Data is not a valid string for JSON parsing:", Data);
        setAstrodata([]);
        return;
      }

      try {
        const parceData = JSON.parse(Data);
     
        const datas = parceData?.Table || [];
      
        setAstrodata(datas);
      
        setAstroId(datas[0]?.AstroID || "");
      
       
      } catch (parseError) {
        console.error("JSON parsing error:", parseError);
        console.error("Raw data that failed to parse:", Data);
        setAstrodata([]);
      }

    } catch (error) {
      console.error("API call error:", error);
      setAstrodata([]);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    waitingdata();
  }, []
  )



  const filteredAstroData = astrodata?.filter((item) => {
    const query = searchQuery.toLowerCase();
    return (
      item.DisplayName?.toLowerCase().includes(query) ||
      item.EMPID?.toLowerCase().includes(query) ||
      item.RegMobileNo?.toLowerCase().includes(query) ||
      item.EmailID?.toLowerCase().includes(query)
    );
  });


  const getFilteredAndSortedData = () => {
    let filteredData = astrodata || [];

    if (filters.name) {
      filteredData = filteredData.filter(item =>
        item.DisplayName?.toLowerCase().includes(filters.name.toLowerCase())
      );
    }
    if (filters.mobile) {
      filteredData = filteredData.filter(item =>
        item.RegMobileNo?.includes(filters.mobile)
      );
    }
    if (filters.status) {
      filteredData = filteredData.filter(item =>
        filters.status === 'active' ? item.IsActive : !item.IsActive
      );
    }


    if (sortField) {
      filteredData.sort((a, b) => {
        const aValue = a[sortField];
        const bValue = b[sortField];

        if (typeof aValue === 'string' && typeof bValue === 'string') {
          return sortOrder === 'asc'
            ? aValue.localeCompare(bValue)
            : bValue.localeCompare(aValue);
        }

        return sortOrder === 'asc'
          ? (aValue > bValue ? 1 : -1)
          : (aValue < bValue ? 1 : -1);
      });
    }

    return filteredData;
  };

  const data = [
    {
      AstroID: 1,
      Name: 'Acharya Ram',
      Department: 'Vedic',
      Skills: 'Love,Career,Health',
      LastSeen: '2 min ago',
      NextAvailable: 'Now',
      IsOnline: true,
    },
    {
      AstroID: 2,
      Name: 'Guru Meera',
      Department: 'Tarot',
      Skills: 'Marriage,Finance',
      LastSeen: 'Today 6:45 AM',
      NextAvailable: 'Tomorrow 9:00 AM',
      IsOnline: false,
    },
  ];







  const handleResetFilters = () => {
    setFilters({ name: '', mobile: '', status: '' });
    setSortField('');
    setSortOrder('asc');
    //   setCurrentPage(1);
  };

 const fetchAstroTimeSlotData = async () => {

    const sevenDaysInMilliseconds = 7 * 24 * 60 * 60 * 1000;
    const dateSevenDaysAgo = new Date(Date.now() + sevenDaysInMilliseconds);
    const val = { FromDate: new Date(), ToDate: dateSevenDaysAgo, AstroId: astroId, };
    try {
      const response = await AddUpdate("AstroTimeSlot/GetData_AstroTimeSlot", val);
      if (response) {
       
        setTimeData(response?.slice(1));
        setFirstrowData(response[0]);
        
      }
    } catch (error) {
      console.error("Error fetching time slot data:", error);
    }
  };

useEffect(()=>{
    fetchAstroTimeSlotData()
},[])


 const Get_AstroAvailable = async () => {
  
    const sevenDaysInMilliseconds = 7 * 24 * 60 * 60 * 1000;
    const dateSevenDaysAgo = new Date(Date.now() + sevenDaysInMilliseconds);
    const val = {
      FromDate: new Date(),
      ToDate: dateSevenDaysAgo,
      // AstroId: GetAstroLoginId,
    };
    try {
      const response = await AddUpdate("AstroTimeSlot/AstroAvailable", val);
      
      // Add proper null checks and error handling
      if (!response || !response.data) {
        console.error("API response is empty or invalid");
        setAstroAvailabledata([]);
        return;
      }

      const Data = response?.data?.data;
      
      // Check if Data exists and is a string before parsing
      if (!Data || typeof Data !== 'string') {
        console.error("Data is not a valid string for JSON parsing:", Data);
        setAstroAvailabledata([]);
        return;
      }

      try {
        const parceData = JSON.parse(Data);
        const datas = parceData?.Table || [];
        setAstroAvailabledata(datas);
       
      } catch (parseError) {
        console.error("JSON parsing error:", parseError);
        console.error("Raw data that failed to parse:", Data);
        setAstroAvailabledata([]);
      }
     
    } catch (error) {
      console.error("Error fetching time slot data:", error);
      setAstroAvailabledata([]);
    }
  };
useEffect(() => {
    Get_AstroAvailable();
  }, []);

    const HandleClickTimeTable = () => {
      
    setIsTimeTableOpen(!isTimeTableOpen);
    Get_AstroAvailable();
  };
  


  if (loading) {
    return <Loader />;
  }


  const scheduleData = [
    { time: '09:00 AM - 10:00 AM', status: 'Booked' },
    { time: '10:00 AM - 11:00 AM', status: 'Available' },
    { time: '11:00 AM - 12:00 PM', status: 'Break' },
    { time: '12:00 PM - 01:00 PM', status: 'Available' },
  ];

  const statusColor = (status) => {
    if (status === 'Booked') return 'text-danger';
    if (status === 'Available') return 'text-success';
    if (status === 'Break') return 'text-warning';
    return '';
  };

  const customCss = `
    .astrologer-availability .title {
        color: #F97316; 
    }
    .astrologer-card {
        border: 1px solid #e5e7eb;
        border-radius: 0.75rem;
        box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
        transition: all 0.3s ease;
    }
    .astrologer-card:hover {
        box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
        transform: translateY(-2px);
    }
    .status-badge {
        font-size: 0.75rem;
        padding: 0.25em 0.6em;
        border-radius: 9999px;
        font-weight: 500;
    }
    .status-badge.online {
        color: #166534;
        background-color: #dcfce7;
    }
    .status-badge.offline {
        color: #374151;
        background-color: #e5e7eb;
    }
    .skill-badge {
        display: inline-block;
        background-color: #ffedd5;
        color: #f97316;
        font-size: 0.75rem;
        padding: 0.25rem 0.5rem;
        border-radius: 9999px;
        margin-right: 0.5rem;
        margin-bottom: 0.25rem;
    }
    .btn-view-schedule {
        border: 1px solid #f97316;
        color: #f97316;
        background-color: transparent;
    }
    .btn-view-schedule:hover {
        background-color: #ffedd5;
        color: #f97316;
    }
    .form-control:focus {
        border-color: #f97316;
        box-shadow: 0 0 0 0.25rem rgb(249 115 22 / 25%);
    }
    .modal-schedule .modal-content {
        border-radius: 16px;
        box-shadow: 0 8px 32px rgba(0,0,0,0.15);
    }
    .modal-schedule .modal-header {
        border-bottom: none;
        padding-bottom: 0;
    }
    .modal-schedule .modal-title {
        font-size: 1.25rem;
        font-weight: 600;
    }
    .modal-schedule .close {
        font-size: 1.2rem;
        font-weight: bold;
        color: #333;
        opacity: 1;
    }
    .modal-schedule .schedule-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.5rem 0;
        font-size: 1rem;
    }
    .modal-schedule .schedule-row:not(:last-child) {
        border-bottom: 1px solid #f3f3f3;
    }
    .modal-schedule .text-danger { color: #dc2626 !important; }
    .modal-schedule .text-success { color: #16a34a !important; }
    .modal-schedule .text-warning { color: #f59e42 !important; }
  `;

  const closeModalTimetable = () => {
    setTimetableIsPopupOpen(false);
  };

  return (
    <>
      <style>{customCss}</style>
      <div className="container-fluid astrologer-availability  p-4">
        <h2 className="heading">Astrologer Availability</h2>
        <div className="mb-4">
          <input
            type="text"
            placeholder="Search Astrologer..."
            className="form-control"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          
         
        
        </div>
        <div className="row g-4" style={{ maxHeight: '80vh', overflowY: 'auto', paddingBottom: '20px' }}>
        
          <div className="col-12 mb-3">
          
          </div>
          
          {astrodata && astrodata.length > 0 ? (
            astrodata?.map((item) => (
              <div key={item?.AstroID} className="col-12 col-sm-6 col-lg-4 d-flex">
                <div className="card astrologer-card h-100 w-100">
                  <div className="card-body d-flex flex-column">
                    <div className="d-flex justify-content-between align-items-start mb-2">
                      <h5 className="card-title mb-0 fw-bold">{item?.DisplayName}</h5>
                      <span className={`status-badge ${item.LastOnlineTime ? 'online' : 'offline'}`}>
                        {item?.LastOnlineTime ? 'Online' : 'Offline'}
                      </span>
                    </div>
                   
                    <div className="mb-2">
                      <strong className='fw-bold'>Skills:</strong>{' '}
                      {item?.skills?.split(',').map((skill, idx) => (
                        <span key={idx} className="skill-badge">
                          {skill}
                        </span>
                      ))}
                    </div>
                    <p className="card-text text-muted mb-1">
                      <strong className='fw-bold'>Last Seen:</strong> {item?.LastOnlineTime}
                    </p>
                    <p className="card-text text-muted mb-3">
                      <strong className='fw-bold'>Next Available:</strong> {item?.NextOnlineTime}
                    </p>
                     <p className="card-text text-muted mb-3">
                      <strong className='fw-bold'>Date:</strong> {item?.Dates}
                    </p>
                    <p
      style={{ cursor: "pointer", color: "blue" }}
      onClick={() => console.log("hello")}
      className="card-text text-muted mb-3"
    >
      <strong className="fw-bold">WaitingList:</strong> {item?.WaitingList}
    </p>

                    <div className="mt-auto">
                      <button className="btn btn-view-schedule w-100"
                      // onClick={() => { setSelectedAstro(item); setShowModal(true); }}
                       onClick={() => setTimetableIsPopupOpen(true)}
                        >
                        View Schedule
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12 text-center py-5">
              <div className="alert alert-info" role="alert">
                <h4 className="alert-heading">No Astrologers Available</h4>
                <p>There are currently no astrologers available. Please check back later or contact support if this issue persists.</p>
                <hr />
                <p className="mb-0">
                  <button 
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => window.location.reload()}
                  >
                    Refresh Page
                  </button>
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
      



     {TimetablePopUPOpen && (
  <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
    <div className="modal-dialog modal-xl modal-dialog-centered">
      <div className="modal-content">

       
        <div className="modal-header" style={{ backgroundColor: '#ff4d4d' }}>
          <h5 className="modal-title text-white">Time Table</h5>
          <button type="button" className="btn-close btn-close-white" onClick={closeModalTimetable}></button>
        </div>

       
        <div className="modal-body">
          <div className="container-fluid">
            <div className="row text-center">
              {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((day, index) => {
                const item = AstroAvailabledata?.find((d) =>
                  d.DayName.toLowerCase().startsWith(day.toLowerCase())
                );

                const timeSlots = ["9:00 - 12:00", "12:00 - 15:00", "15:00 - 18:00"];
                const activeSlots = item?.EmployeeNames?.split(",").map((s) => s.trim()) || [];
                const isLeave = item?.IsLeave === "1" || item?.IsLeave === 1;

                return (
                  <div key={index} className="col-6 col-sm-4 col-md-3 col-lg">
                    <div className="bg-warning text-white fw-semibold py-1 rounded mb-2">
                      {day}
                    </div>
                    {timeSlots.map((slot, i) => (
                      <div
                        key={i}
                        className={`py-1 mb-1 rounded small ${
                          isLeave
                            ? 'bg-danger text-white'
                            : activeSlots.includes(slot)
                              ? 'bg-success text-white'
                              : 'bg-light text-muted'
                        }`}
                      >
                        {isLeave ? "On Leave" : slot}
                      </div>
                    ))}
                  </div>
                );
              })}
            </div>
          </div>
        </div>

      
        <div className="modal-footer justify-content-center">
          <button className="btn btn-danger px-5" 
        
          >
            Edit Time Table
          </button>
        </div>
      </div>
    </div>
  </div>
)}

{isTimeTableOpen && (
        <div
          className="flex bg-black bg-opacity-50 justify-center p-10 fixed inset-0 items-center"
          style={{ zIndex: 99999 }}
        >
          <div className="bg-white p-8 rounded-lg shadow-lg w-full">
            <button
              className="float-right text-3xl text-gray-800 hover:text-red-500"
              onClick={HandleClickTimeTable}
            >
              &times;
            </button>
            <AstroTimeTable />
          </div>
        </div>
      )}







      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        className="modal-schedule"
      >
        <Modal.Header closeButton>
          <Modal.Title>Schedule for {selectedAstro?.DisplayName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {scheduleData.map((slot, idx) => (
            <div className="schedule-row" key={idx}>
              <span>{slot.time}</span>
              <span className={statusColor(slot.status)}>{slot.status}</span>
            </div>
          ))}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default WaitingList